/**
 * ownerRouteMap.js — Carte page ↔ URL du shell propriétaire (Sprint routeur, Lot 0+1).
 *
 * PHASE DE COEXISTENCE (Lot 0+1 → retirée au Lot 3/5) :
 *   - PAGE_TO_PATH / PATH_TO_PAGE : les pages SANS paramètre routées ce lot.
 *     L'URL fait foi pour ces pages (rendu via <Routes> dans OwnerRoutes).
 *   - NON_ROUTED_PAGES : pages encore pilotées par `currentPage` (état React),
 *     non routées ce lot (paramétrées : detail/health/live/compare ; légales).
 *     Tant que `currentPage` ∈ NON_ROUTED_PAGES, App rend le switch legacy
 *     (l'override prime sur <Routes>). Sinon, <Routes> rend selon l'URL.
 *
 * Frontière temporaire : Lot 2 routera les paramétrées (/sessions/:id, /horses/:id…),
 * Lot 3 les légales (/legal/*), après quoi `currentPage` et cette carte disparaissent.
 */
import { PAGES } from '../constants/pages';

// Pages sans paramètre routées au Lot 0+1.
export const PAGE_TO_PATH = Object.freeze({
  [PAGES.LIST]:      '/sessions',
  [PAGES.HORSES]:    '/horses',
  [PAGES.NEW_HORSE]: '/horses/new',
  [PAGES.PROFILE]:   '/account',   // settings/UserProfile — ≠ /profil (profile/ProfilePage)
  [PAGES.ADMIN]:     '/admin',
  [PAGES.FEEDBACK]:  '/feedback',
  [PAGES.FAQ]:       '/faq',
  [PAGES.NOTICE]:    '/notice',
  [PAGES.UPLOAD]:    '/import',
});

export const PATH_TO_PAGE = Object.freeze(
  Object.fromEntries(Object.entries(PAGE_TO_PATH).map(([page, path]) => [path, page]))
);

// Pages encore pilotées par currentPage (non routées ce lot). L'override de
// rendu les fait primer sur <Routes> tant que currentPage vaut l'une d'elles.
export const NON_ROUTED_PAGES = Object.freeze(new Set([
  PAGES.DETAIL, PAGES.HEALTH, PAGES.LIVE, PAGES.COMPARE,
  PAGES.CGU, PAGES.MENTIONS, PAGES.PRIVACY, PAGES.COOKIES,
  PAGES.MODERATION, PAGES.CGV, PAGES.SUPPORT,
]));
